import { Injectable } from '@angular/core';
import { ApiMyServicesService } from '@core/api/services/my-services/api-my-services.service';

import { MyServicesListingMapper } from '@core/domain/mappers/services/my-services-listing.mapper';
import { errorFromHttpErrorResponse } from '@core/services/request/util/error-from-http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { myServicesActions } from '@store/actions/my-services.actions';
import { myServicesSelectors } from '@store/selectors/my-services.selectors';
import { StoreState } from '@store/store.state';
import { switchMap, map, catchError, of } from 'rxjs';

@Injectable()
export class MyServicesEffects {
  fetchListingData$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(myServicesActions.fetchListingData),
      switchMap(() =>
        this._apiService
          .fetchMyServices(
            MyServicesListingMapper.servicesFilterFromDomainToApi(this._store.selectSignal(myServicesSelectors.listingDataFiltersSig)())
          )
          .pipe(
            map((apiResponse) => MyServicesListingMapper.societyRequestFromApiToDomain(apiResponse)),
            map((response) => response.data.values),
            map((data) => ({
              superData: data,
              subData: data.reduce(
                (previousValue, currentValue) => ({
                  ...previousValue,
                  [currentValue.id]: [...currentValue.installations],
                }),
                {}
              ),
            })),
            map((data) => myServicesActions.setListingData(data)),
            catchError((error) => of(myServicesActions.setListingDataError({ error: errorFromHttpErrorResponse(error) })))
          )
      )
    );
  });

  constructor(
    private readonly _actions$: Actions,
    private readonly _apiService: ApiMyServicesService,
    private readonly _store: Store<StoreState>
  ) {}
}
